const Style = {
    categoryContainer: {
        p: 2,
        my: 2,

        width: '100%',
        backgroundColor: 'background.paper',
        borderRadius: 2,
        borderBottom: '1px solid #CCD5D5'
    },

    loadingContainer: {
        p: 2,
        my: 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        backgroundColor: 'background.paper',
        borderRadius: 2,
        borderBottom: '1px solid #CCD5D5'
    },
    categoryHeader: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: '100%',
        mb: 1
    },
    categoryTitle: {
        color: 'text.primary',
        textAlign: 'left',
        letterSpacing: 0.2,
        fontSize: 18,
        fontWeight: 500,
        cursor: 'pointer',
        transition: 'all 0.3s ease',

        '&:hover': {
            color: '#16CECC'
        }
    },
    categoryListContainer: {
        width: '100%',
        overflowX: 'auto',
        '&::-webkit-scrollbar': {
            height: 8
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.2)',
            borderRadius: 4
        }
    },
    categoryList: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        p: 1,
        width: '100%',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            height: 8
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.2)',
            borderRadius: 4
        }
    },
    // Mobile-only horizontal scroll layout (Shopee/Lazada style)
    categoryListMobile: {
        display: 'flex',
        flexWrap: 'nowrap',
        overflowX: 'auto',
        overflowY: 'hidden',
        gap: 1.5,
        px: 1.5,
        py: 1.5,
        width: '100%',
        scrollBehavior: 'smooth',
        WebkitOverflowScrolling: 'touch',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        scrollSnapType: 'x mandatory'
    },
    categoryCard: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 1.3,
        height: 100,
        borderRadius: 4,
        cursor: 'pointer',
        boxShadow: 2,
        transition: 'all 0.3s ease',
        '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: 2,
            backgroundColor: 'primary.light'
        },
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: 'background.default'
    },
    // Mobile category card: touch-friendly, icon + label stacked
    categoryCardMobile: {
        flexShrink: 0,
        minWidth: 72,
        width: 72,
        height: 'auto',
        minHeight: 88,
        p: 1.5,
        borderRadius: 2.5,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        scrollSnapAlign: 'start',
        '&:active': {
            transform: 'scale(0.96)'
        }
    },
    categoryIconWrapperMobile: {
        width: 48,
        height: 48,
        minWidth: 48,
        minHeight: 48,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'rgba(21, 205, 203, 0.12)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        mb: 1
    },

    iconCategory: {
        height: 'auto',
        display: 'block',
        justifyContent: 'center',
        alignItems: 'center',
        // Every category icon (font, SVG or picture mask) inherits this, so all of them follow the theme
        color: 'text.primary',
        transition: 'color 0.3s ease'
    },

    iconContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        mb: 2,
        '& > *': {
            fontSize: '2.5rem',
            color: 'primary.main'
        }
    },
    categoryLabel: {
        fontSize: '0.875rem',
        textAlign: 'center',
        color: 'text.primary',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontWeight: 500
    },
    hoverOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: 0,
        color: 'white',
        transition: 'opacity 0.3s ease',
        '&:hover': {
            opacity: 1
        }
    },
    hoverLabel: {
        color: 'white',
        textAlign: 'center',
        padding: '8px',
        fontSize: '1rem',
        fontWeight: 600
    },
    // categoryContainer: {
    //     display: 'flex',
    //     flexDirection: 'column',
    //     justifyContent: 'center',
    //     alignItems: 'center',
    //     pb: 2,

    //     pt: { xs: 1, sm: 2 },
    //     mt: { xs: 2, sm: 3 },
    //     width: '100%',
    //     justifyItems: 'center'
    // },
    // categoryTitle: {
    //     fontWeight: 500,
    //     fontSize: 18,
    //     textAlign: 'left',
    //     width: '100%',
    //     p: { xs: 1, sm: 2 }
    // },
    // categoryList: {
    //     mt: 1,
    //     display: 'flex',
    //     flexWrap: 'wrap',
    //     justifyContent: 'center',

    //     width: '100%',
    //     overflow: 'auto'
    // },
    // categoryCard: {
    //     display: 'flex',
    //     flexDirection: 'column',
    //     alignItems: 'center',

    //     m: 1,
    //     p: { xs: 0.5, sx: 1 },
    //     justifyContent: 'center',
    //     borderRadius: 2,
    //     cursor: 'pointer'
    // },
    categoryIconContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50%',
        p: 0,
        m: 0,
        pt: 0.7
    },
    categoryIcon: {
        width: '75px',
        height: 'auto',
        display: 'block',
        justifyContent: 'center',
        alignItems: 'center'
    },
    categoryTextContainer: {
        height: '50%',
        p: 0,
        m: 0,
        pt: 1,
        display: 'flex'
    },
    categoryText: {
        color: 'text.primary',
        transition: 'color 0.3s ease',
        fontSize: 12,
        fontWeight: '500',
        textAlign: 'center',
        width: 80,
        cursor: 'pointer',
        letterSpacing: -0.5
    },
    categoryLabelMobile: {
        fontSize: 11,
        fontWeight: 500,
        textAlign: 'center',
        width: 64,
        maxWidth: 64,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        lineHeight: 1.2,
        display: 'block'
    },
    sub_btns: {
        p: 2,
        boxShadow: '5px 5px 5px rgba(0,0,0,0.2)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        bgcolor: '#16CECC',

        border: '1px solid',
        borderColor: '#16CECC',
        borderRadius: '12px',
        fontSize: 12,
        '&:hover': {
            backgroundColor: '#14A896',
            border: '1px solid',
            borderColor: '#14A896',
            animation: 'borderPulse 1s ease-in-out infinite alternate'
        }
    },
    active_btns: {
        p: 2,
        boxShadow: '5px 5px 5px rgba(0,0,0,0.2)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#000',
        bgcolor: '#ffffff',

        border: '1px solid',
        borderColor: '#16CECC',
        borderRadius: '12px',
        fontSize: 12,
        '&:hover': {
            backgroundColor: '#14A896',
            border: '1px solid',
            borderColor: '#14A896',
            animation: 'borderPulse 1s ease-in-out infinite alternate'
        }
    },

    '@keyframes pulse': {
        '0%': {
            boxShadow: '0px 0px 0px 0px rgba(20,169,150,0.2)'
        },
        '100%': {
            boxShadow: '0px 0px 0px 8px rgba(20,169,150,0.2)'
        }
    },

    '@keyframes hoverPulse': {
        '0%': {
            boxShadow: '0px 0px 0px 0px rgba(20,169,150,0.2)'
        },
        '100%': {
            boxShadow: '0px 0px 0px 8px rgba(20,169,150,0.2)'
        }
    },

    '@keyframes borderPulse': {
        '0%': {
            boxShadow: '0px 0px 0px 0px rgba(20,169,150,0.2)'
        },
        '100%': {
            boxShadow: '0px 0px 0px 8px rgba(20,169,150,0.2)'
        }
    }
};
export default Style;
